"use strict";

define(['mw-remote/RemoteEndPointsManager', 'dojo/_base/xhr', 'dojo/_base/Deferred'], function (RemoteEndPointsManager, xhr, Deferred) {
  var sendDataUsingIFrame = function sendDataUsingIFrame(data, endPoint, options) {
    var iframeProxyClient = RemoteEndPointsManager.getIframeProxyClientForEndPoint(endPoint);
    return iframeProxyClient.sendMessage(data, RemoteEndPointsManager.getRemoteUrlForEndPoint(endPoint), options);
  };

  var sendDataUsingXhr = function sendDataUsingXhr(data, endPoint, options) {
    var headers = options && options.headers ? options.headers : null;
    return xhr.post({
      url: RemoteEndPointsManager.getRemoteUrlForEndPoint(endPoint),
      // set the content type to json so that chrome
      // knows how to display it properly. the server ignores this.
      contentType: 'application/json',
      handleAs: 'json',
      // todo: Determine a way to handle message level timeouts. Some requests need to be
      // unbounded, but not all of them.
      // timeout: 10000,
      headers: headers,
      postData: data
    });
  };
  /**
   * Utility function to select the implementation to be used to send data to the server
   * Determines whether or not IFrame is needed for a partciular endpoint.
   */


  return {
    /**
     * This method is used to send thoptionse data. It fetches iframeProxyClient from the
     * RemoteEndPointsManager and
     * sends the message.
     * @param {object} data - data to send
     * @param {object} endPoint - endPoint to which the data is to be sent
     * @param {object} options - optional headers
     * @return {*} a promise
     */
    sendPayload: function sendPayload(data, endPoint, options) {
      var checkDirectXhrAllowed = RemoteEndPointsManager.getEndPointAllowsDirectXhr(endPoint);
      var messageResponse = new Deferred();
      checkDirectXhrAllowed.then(function (directXhrAllowed) {
        var result;

        if (directXhrAllowed.status === RemoteEndPointsManager.DirectXhrConstants.ENABLED) {
          result = sendDataUsingXhr(data, endPoint, options);
        } else {
          result = sendDataUsingIFrame(data, endPoint, options);
        }

        result.then(function (responseData) {
          messageResponse.resolve(responseData);
        });
      });
      return messageResponse;
    }
  };
});
//# sourceMappingURL=SendMessageUtil.js.map
